import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Paper,
  CardMedia,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { headers } from "../../utils/utils";

const BoardSelection = ({ open, onClose }) => {
  const [boards, setBoards] = useState([]);

  useEffect(() => {
    fetchBoards();
  }, []);
 
  const fetchBoards = async () => {
    console.log("INSIDE FETCH");
    try {
      const response = await fetch(
        process.env.REACT_APP_SYS_CONFIG_MGMT +
        "/systemConfig/config?name=Board&active=true",
        {
          method: "GET",
          headers: headers(),
        },
      );
      const data = await response.json();
      setBoards(data);
    } catch (error) {
      console.error("Error fetching boards:", error);
    }
  };

  const handleBoardSelect = (board) => {
    localStorage.setItem("board", board.id);
    window.location.reload();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      sx={{
        "& .MuiDialog-paper": {
          margin: "0px",
        },
      }}
    >
      <DialogContent>
        <br />
        {boards && boards.length === 0 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f5f5f5",
              p: 4,
            }}
          >
            <Paper
              elevation={4}
              sx={{
                maxWidth: 800,
                textAlign: "center",
                padding: 4,
                borderRadius: 2,
                backgroundColor: "#ffffff",
              }}
            >
              <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
                Welcome to Our Platform!
              </Typography>
              <Typography variant="body1" gutterBottom>
                We're excited to have you on board. Explore the features, stay
                updated, and let's achieve great things together!
              </Typography>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                sx={{ mt: 3 }}
              >
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={onClose}
                    sx={{ textTransform: "none", px: 3 }}
                  >
                    Get Started
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    color="secondary"
                    sx={{ textTransform: "none", px: 3 }}
                  >
                    Learn More
                  </Button>
                </Grid>
              </Grid>
              <Typography
                variant="caption"
                display="block"
                sx={{ mt: 4, color: "#888" }}
              >
                © 2025 eVyoog Team. All Rights Reserved.
              </Typography>
            </Paper>
          </Box>
        )}
        <Grid container spacing={3}>
          {boards &&
            boards.length > 0 &&
            boards.map((board) => (
              <Grid item key={board.id} xs={12} sm={6} md={4}>
                <Card>
                  <CardActionArea onClick={() => handleBoardSelect(board)}>
                    {board.imageUrl && (
                      <CardMedia
                        component="img"
                        height="160"
                        image={board.imageUrl}
                        alt={board.value?.toString() || "Board Image"}
                      />
                    )}

                    <CardContent
                      sx={{
                        background: "linear-gradient(135deg, #2196F3 0%, #1976D2 100%)", // MUI Blue Gradient
                        padding: "20px",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        "&:hover": {
                          transform: "scale(1.05)",
                          boxShadow: "0px 6px 16px rgba(25, 118, 210, 0.5)", // Soft Blue Glow on Hover
                        },
                      }}
                    >
                      <Typography
                        variant="h5"
                        component="div"
                        sx={{
                          textAlign: "center",
                          fontWeight: "bold",
                          color: "#fff",
                          marginBottom: board.description ? "8px" : 0,
                          textTransform: "uppercase",
                          letterSpacing: "1px",
                        }}
                      >
                        {board.value?.toString() || "Unnamed Board"}
                      </Typography>

                      {board.description && (
                        <Typography
                          variant="body2"
                          color="white"
                          sx={{
                            textAlign: "center",
                            fontSize: "14px",
                            marginTop: "4px",
                            opacity: 0.9, // Slightly softer text for readability
                          }}
                        >
                          {board.description}
                        </Typography>
                      )}
                    </CardContent>


                  </CardActionArea>
                </Card>
              </Grid>
            ))}
        </Grid>
        <br />
      </DialogContent>
    </Dialog>
  );
};

export default BoardSelection;
